<template>
<div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
   
        <v-card class="box">
            <span v-if="edit_fee_receipt!=null">
                 <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Edit Student Fee Receipt {{edit_fee_receipt.receipt_no}}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
                <br />
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field dense outlined rounded v-model="edit_fee_receipt.remark" persistent-hint label="Edit Remark"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete dense outlined rounded item-value="name" item-text="name" :items="payment_mode_list" v-model="edit_fee_receipt.paymentmode" label="Edit Payment Mode"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hint="YYYY/MM/DD format" persistent-hint v-model="edit_fee_receipt.receipt_date" label="Edit Receipt Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="edit_fee_receipt.receipt_date" @input="menu = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                    <v-text-field dense outlined rounded v-model="edit_fee_receipt.transaction_id" persistent-hint label="UTR Number" placeholder="Enter UTR Number"></v-text-field>
                </v-col>
                        <!-- <v-col v-if="org_id == 'wws'" cols="12" sm="3" md="3">
                             <v-autocomplete dense rounded required :items="bank_list" v-model="edit_fee_receipt.bank_name" label="Bank" name="bank" item-text="name" item-value="name" outlined></v-autocomplete>
                        </v-col>
                         <v-col v-if="org_id == 'wws'" cols="12" sm="3" md="3">
                            <v-text-field outlined rounded label="Branch Name" v-model="edit_fee_receipt.branch_name" placeholder="SBU Pune" name="branch_name" dense></v-text-field>
                        </v-col>
                        <v-col v-if="org_id == 'zeal' || org_id == 'wws'" cols="12" sm="3" md="3">
                            <v-text-field outlined rounded label="Transaction ID" v-model="edit_fee_receipt.trans_id" placeholder="123" name="trans_id" dense></v-text-field>
                        </v-col> -->
                </v-row>
            </span>
            <v-row justify="center" dense>
                <v-btn class="button mt-3" @click="editFeeReceipt()">Save</v-btn>
            </v-row>
        </v-card>
</div>
</template>
<script>
    import axios from "axios";
    export default {
        props: ['payment_mode_list','dialog_edit_fee'],
        data: () => ({
            edit_fee_receipt: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            menu1: false,
            modal1: false,
            modal2: false,
            edit_id: "",
            menu: false,
            modal: false,
            menu2: false,
            org_id:null,
        }),

        mounted() {
            this.edit_fee_receipt = this.$store.getters.receipt_data;
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        methods: {
             showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editFeeReceipt() {
                const formData = {
                    edit_fee_receipt: this.edit_fee_receipt,
                };
                axios
                    .post("/ParentTransport/editTransportFeeReceipt", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Student Transport Fee Receipt edited successfully");
                           // this.dialog_edit_fee = false
                            this.$emit('changedialog',false);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 100%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
</style>